import React from "react";
import images from "../../images";
import Button from "../common/Button/Button";
import { calculateDays } from "../../Utils/helper";
import ImageSliderPreviewOndermand from "../common/SlideShowImage/ImagesSliderPreviewOndermand";
import { useTranslation } from "react-i18next";

const TaskQuest = ({
  imagesNameShop,
  shopName,
  branchName,
  description,
  thumbnails,
  handleTaskQuest,
  token,
  estTime,
  expireIn,
  slotAvailable,
  // favoritesIcon,
  consumerStatus,
  businessId,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center px-2.5 py-3 w-full bg-white rounded-xl border border-solid border-stone-200">
      <ImageSliderPreviewOndermand images={thumbnails} />
      <div className="flex gap-10 justify-between items-center w-full">
        <div className="flex gap-1.5 items-center self-stretch my-auto mt-4">
          <img
            loading="lazy"
            src={imagesNameShop}
            className="object-cover shrink-0 self-stretch my-auto aspect-square max-w-[35px] rounded-full"
            alt="Chicken Rice Icon"
          />

          <div className="flex flex-col justify-center self-stretch my-auto">
            <div className="text-lg font-semibold text-zinc-800">
              {shopName}
            </div>
            <div className="mt-1 text-xs text-neutral-500">{branchName}</div>
          </div>
        </div>
        <button className="flex overflow-hidden flex-col justify-center items-center self-stretch px-0.5 py-2 my-auto min-w-7 border border-solid border-slate-200 min-h-7 rounded-[100px]">
          <img
            loading="lazy"
            src={images.FavoritesIcon}
            className="object-contain w-3.5 aspect-[1.17]"
            alt="Favorite"
          />
        </button>
      </div>
      <div className="self-start mt-4 text-sm text-neutral-500">
        {description}
      </div>
      <div className="flex gap-3 mt-4 w-full min-h-[72px]">
        <div className="flex flex-col flex-1 shrink justify-between items-center py-2.5 whitespace-nowrap bg-yellow-50 rounded-xl basis-0">
          <div className="text-xs text-center text-zinc-800">Coins</div>
          <div
            className="flex justify-center items-center
 mt-2.5 text-2xl font-semibold text-indigo-600"
          >
            <img
              loading="lazy"
              src={images.PointIconBlue}
              className="object-contain shrink-0 aspect-square w-[26px]"
              alt=""
            />
            <div>{token}</div>
          </div>
        </div>
        <div className="flex flex-col flex-1 shrink justify-between items-center py-2.5 whitespace-nowrap bg-yellow-50 rounded-xl basis-0">
          <div className="text-xs text-center text-zinc-800">
            {t("common.takeQuest.estTime")}
          </div>
          <div className="flex justify-center items-start mt-2.5 text-2xl font-semibold text-indigo-600">
            <div>
              ~{estTime} {t("common.takeQuest.mins")}
            </div>
          </div>
        </div>
        <div className="flex flex-col flex-1 shrink justify-between items-center py-2.5 whitespace-nowrap bg-yellow-50 rounded-xl basis-0">
          <div className="text-xs text-center text-zinc-800">
            {t("common.takeQuest.expireIn")}
          </div>
          <div className="flex justify-center items-start mt-2.5 text-2xl font-semibold text-indigo-600">
            {calculateDays(expireIn) > 1 ? (
              <div>{calculateDays(expireIn)} days</div>
            ) : (
              <div>{calculateDays(expireIn)} day</div>
            )}
          </div>
        </div>
      </div>

      {/* <QuestCard thumbnails={thumbnails} businessId={businessId} /> */}
      <div className="flex overflow-hidden gap-2 items-center px-2 py-2 mt-4 w-full text-xs rounded-xl bg-teal-500 bg-opacity-20 min-h-[36px]">
        <img
          loading="lazy"
          src={images.TickIcon}
          className="object-contain shrink-0 self-stretch my-auto w-4 aspect-square"
          alt=""
        />
        <div className="flex-1 shrink self-stretch my-auto font-medium leading-none text-teal-500 basis-3">
          {t("common.takeQuest.youAreEligible")}!
        </div>
        <div className="gap-2.5 self-stretch px-1.5 py-1 my-auto text-center rounded-md bg-neutral-50 min-h-[22px] text-neutral-500">
          <span className="font-medium text-zinc-800">{slotAvailable}</span>
          <span className=""> {t("common.takeQuest.slotLeftsCustomer")}</span>
        </div>
      </div>
      {consumerStatus && (
        <Button
          text={
            consumerStatus === "NOT_STARTED"
              ? t("common.takeQuest.takeQuest")
              : consumerStatus === "COMPLETED"
              ? t("common.takeQuest.done")
              : t("common.takeQuest.continue")
          }
          onClick={handleTaskQuest}
          className="gap-2.5 self-stretch px-5 py-4 mt-4 w-full text-lg font-semibold tracking-wide text-center text-white bg-[#3F54DF] rounded-xl min-h-[54px]"
        />
      )}
    </div>
  );
};

export default TaskQuest;
